import React from 'react';
import CardLabelAndTitle from '../../../../../components/CardLabelAndTitle';
import { memberCardDetails } from '../MemberDetailsCard.data';
import Styles from './MemberInformation.module.scss';

interface IMemberInformation{
  payload:any;
}
const MemberInformation = ({ payload }:IMemberInformation) => (
  <div className={Styles.wrapper}>
    <h4 className={Styles.wrapper__title}>Personal’s Info</h4>
    {memberCardDetails?.map(({ attribute, label, id }) => (
      <CardLabelAndTitle
        key={id}
        content={payload}
        attribute={attribute}
        label={label}
      />
    ))}
  </div>
);

export default MemberInformation;
